import { useContext, useState, useEffect, useMemo } from 'react';
import FormContext from '../../../context/form-context';
import { Form, Type, defaultForm, defaultType } from '../../../constants/form-type';
import { distinctObjectFromArray } from '../../../utils/utilities';
import { setAlert, setFormTypeField, setTemplatesField } from '../../../state/action';
import { getMainFieldsTable } from '../../../services/firebase/mainFields/mainFieldsTable'
import { MODE } from '../../../constants/form-mode';
import { useLocation } from 'react-router-dom';

export const useFormType = () => {
   const { appState, dispatch } = useContext(FormContext);
   const [typeOptions, setTypeOptions] = useState(defaultType);
   const [formOptions, setFormOptions] = useState(defaultForm);
   const [fieldDisable, setFieldDisable] = useState(false);
   const [mainFields , setMainFields] = useState([]);
   const { 
      formTemplatesList , 
      formType , 
      formInfo,
      error,
   } = appState;

   const form = formType.form;
   const type = formType.type;
   const mode = formInfo.mode;

   const location = useLocation();
   const routeForm = location.state?.form
   const routeType = location.state?.type

   useEffect(() => {
      const getMainFields = async () => {
         const commonFields = await getMainFieldsTable();
         setMainFields(commonFields)
         
         setTypeOptions(distinctObjectFromArray(commonFields, Type)); //formTemplatesList
         setFormOptions(distinctObjectFromArray(commonFields, Form));
      }

      getMainFields(); //get the main fields
      
      if (routeForm && routeType) {
         dispatch(setFormTypeField({
            ...formType,   
            form: routeForm,
            type: routeType
         }))
      }

   }, [])

   useMemo(() => {
      setFieldDisable(mode===MODE.NEW ? false : true)
   }, [mode])

   useEffect(  () => {
      const getCommonFields = async (form, type) => {
         // const formCommonFields = await getMainFieldsByFormType(form, type)

         // filter with form
         const formCommonFields = mainFields.find( item => item.Form === form && item.Type === type) 
         // const formCommonFields = mainFields.find( item => item.Type === type)
         
         dispatch( setFormTypeField( {
            ...appState.formType, 
            fields: formCommonFields?.Fields , 
            sections: formCommonFields?.Sections}) 
         )
      }

      if((form && type) && mode===MODE.NEW ){
         getCommonFields(form , type);
         //reset the selected templates
         dispatch(setTemplatesField([]))
      }
   }, [form , type , mainFields])

   const formTypeEvents = {
      onFormFieldChange: (val) => {
         // if(val === defaultForm[0]){
            dispatch( setFormTypeField( {...formType, form:val}) )
         // }else{
         //    dispatch(setAlert({
         //       show:true,
         //       title: "WARNING",
         //       body: "You are not authorized to make this transaction. <br/><br/>Contact your respective HOD for any BDC closings."
         //    }))
         // }
      },
      onTypeFieldChange: (val) => {
         dispatch( setFormTypeField( {...formType, type:val}) )
      }
   }

   return {
      typeOptions,
      formOptions,
      formType,
      error,
      defaultForm,
      defaultType,
      formTypeEvents,
      fieldDisable
   }

}